import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { NavLink } from "../NavbarStyles";
import {
  DownloadBtn,
  Title,
  ReportInfoForm,
  ReportLabel,
  DatePickerDiv,
  DatePickerBlock,
  CheckboxInput,
  ButtonsDiv,
  DatePickerLabel,
  ToggleSwitchDiv,
  ToggleLabel,
  SwitchInput,
} from "./Styles";
import { AOO_API_HOST } from "../../../env";
import Routes from "../../Data/Routes";

const MachineBreakdownReport = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [includeFaulty, setIncludeFaulty] = useState(false);
  const [includeEventDuration, setIncludeEventDuration] = useState(true);
  const [showEventDurationInDays, setShowEventDurationInDays] = useState(false);
  const [reportFormat, setReportFormat] = useState("CSV");
  const navigate = useNavigate();

  const prepareQueryParams = () => {
    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      includeFaulty,
      includeEventDuration,
      showEventDurationInDays,
    };
  };

  const handleDownloadReport = async (e) => {
    e.preventDefault();

    if (!startDate || !endDate) {
      alert("Please select both start and end dates");
      return;
    }

    const params = prepareQueryParams();
    const endpoint =
      reportFormat === "PDF"
        ? "/aoo-api/Productions/GetMachineBreakdownReport"
        : "/aoo-api/Productions/GetMachineBreakdownReportAsCSV";

    const fileType = reportFormat === "PDF" ? "application/pdf" : "text/csv";
    const fileExtension = reportFormat === "PDF" ? "pdf" : "csv";

    try {
      const response = await axios.get(AOO_API_HOST + endpoint, {
        params,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: fileType })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `machine-breakdown-report-${new Date().toISOString()}.${fileExtension}`
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error(`Error fetching ${reportFormat} report:`, error);
    }
  };

  return (
    <div>
      <NavLink
        onClick={() => navigate(Routes.Main)}
        style={{ marginRight: 30 }}
      >
        Back to menu
      </NavLink>
      <Title>Machine Breakdown Report</Title>
      <ReportInfoForm>
        <form>
          <DatePickerBlock>
            <DatePickerDiv>
              <DatePickerLabel>Start Date: </DatePickerLabel>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                dateFormat="yyyy-MM-dd"
                className="report-datepicker"
              />
            </DatePickerDiv>

            <DatePickerDiv>
              <DatePickerLabel>End Date: </DatePickerLabel>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                dateFormat="yyyy-MM-dd"
                className="report-datepicker"
              />
            </DatePickerDiv>
          </DatePickerBlock>

          <div>
            <ReportLabel>
              <CheckboxInput
                type="checkbox"
                checked={includeFaulty}
                onChange={(e) => setIncludeFaulty(e.target.checked)}
              />
              Include Faulty
            </ReportLabel>
          </div>

          <div style={{ display: "none" }}>
            <ReportLabel>
              <CheckboxInput
                type="checkbox"
                checked={includeEventDuration}
                onChange={(e) => setIncludeEventDuration(e.target.checked)}
              />
              Include Event Duration
            </ReportLabel>
          </div>

          <div>
            <ReportLabel>
              <CheckboxInput
                type="checkbox"
                checked={showEventDurationInDays}
                onChange={(e) => setShowEventDurationInDays(e.target.checked)}
              />
              Show Days Duration Column
            </ReportLabel>
          </div>

          <ToggleSwitchDiv>
            <ToggleLabel>Download as: {reportFormat}</ToggleLabel>
            <SwitchInput
              type="checkbox"
              checked={reportFormat === "CSV"}
              onChange={(e) =>
                setReportFormat(e.target.checked ? "CSV" : "PDF")
              }
            />
          </ToggleSwitchDiv>

          <ButtonsDiv>
            <DownloadBtn onClick={handleDownloadReport}>
              Download {reportFormat}
            </DownloadBtn>
          </ButtonsDiv>
        </form>
      </ReportInfoForm>
    </div>
  );
};

export default MachineBreakdownReport;
